export default "__VITE_ASSET__610kvT7J__"